import API from "./API";

export default class Approval extends API
{
    static async approve(params) {
        return this.post("api/admin/approvals/" + params.webAppLinkHash, params);
    }

    static async multipleApproval(params) {
        return this.post("api/admin/approvals/approve/multiple-approval", params);
    }
}